//@author: devin
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from "@angular/core";
import { S25HelpModule } from "../s25-help/s25.help.module";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { ModalCloseButtonComponent } from "./modal.close.button.component";
import { ModalData } from "./modal.service";
import { S25Util } from "../../util/s25-util";

@Component({
    selector: "s25-modal-header",
    template: `
        <div class="modal-header" [attr.ngbAutofocus]="isInIframe ? true : null">
            <ng-content>
                @if (data?.title === " " && !data?.iconClass) {
                    <span class="empty-title"></span>
                } @else {
                    <h4 class="modal-title">
                        @if (data?.iconClass) {
                            <span class="{{ data!.iconClass }}"></span>
                        }
                        @if (data?.title) {
                            <span>{{ data!.title }}</span>
                        }
                    </h4>
                }
                <div class="modal-header-flex">
                    @if (data?.helpLink) {
                        <s25-help-link
                            class="ngInlineBlock ngFloatRight ngCpointer ngModalHelp c-modalHelp"
                            [helpTopic]="data!.helpLink!"
                        >
                            <s25-ng-icon [type]="'help'" [ariaLabel]="false" />
                        </s25-help-link>
                    }
                    @if (data.closable) {
                        <modal-close-button (close)="data?.closeModal()" />
                    }
                </div>
            </ng-content>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25HelpModule, S25IconComponent, ModalCloseButtonComponent],
})
export class ModalHeaderComponent {
    @Input() data: ModalData | undefined;
    isInIframe = S25Util.isInIframe;
}
